import { create } from 'zustand'
import { ILogin, ILoginInitialState, ILoginState } from '../model/LoginModel';
import { GetEmployeeDetailService, GetMasterDetailService, PostLoginService } from '../services/login-service';
import { LocalStorage, SessionStorage } from '../services/storage';
import { responseData } from './common';
import { TWO_HUNDRED_SUCCESS_CODE } from '../utils/app-common';
import { GetGoodTypeService } from '../services/bayan-service';

const initialValue: ILoginInitialState = {
    loggedInDetails: {},
    employeeDetail: {},
    masterDetail: {},
    commodity: []
}

let LoginStore = ((set) => ({
    ...initialValue,
    PostLoginAction: async (userDetails: ILogin) => {
        const response = await PostLoginService(userDetails);
        sessionStorage.setItem('token', ((response?.data?.accessToken!) || '{}'));
        set({ loggedInDetails: response?.data })
    },
    GetEmployeeDetailAction: async (name: string) => {
        const response = await GetEmployeeDetailService(name);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            SessionStorage.set('employee', JSON.stringify(responseData(response?.data || {})));
            set({ employeeDetail: responseData(response?.data) });
        };
    },
    GetMasterDetailAction: async ({ isRefresh = false }: { isRefresh?: boolean } = {}) => {
        const cached = LocalStorage.get('app-storage');
        if (cached && !isRefresh) {
            set({ masterDetail: JSON.parse(cached) });
            SessionStorage.set('app-storage', JSON.stringify(JSON.parse(cached)));
            // return;
        }
        const response = await GetMasterDetailService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const data = responseData(response?.data || {});
            LocalStorage.set('app-storage', JSON.stringify(data));
            SessionStorage.set('app-storage', JSON.stringify(data));
            set({ masterDetail: data });
        };
    },
    GetCommodityAction: async () => {
        const response = await GetGoodTypeService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            SessionStorage.set('commodity', JSON.stringify(responseData(response?.data || {})));
            set({ commodity: responseData(response?.data) });
        };
    },

    ClearLoginStore: () => set({ employeeDetail: {}, masterDetail: {}, loggedInDetails: {} })
}))

//LoginStore = persist(LoginStore, { name: 'employee', getStorage: () => window.sessionStorage }) ;

export const useLoginStore = create<ILoginState>(LoginStore)